<script setup>
// Кнопки входу під ефір — спільні для гейта (ефір закритий) і для екрана
// «офлайн», де глядач перевіряє доступ наперед. Показуємо рівно ті способи,
// які реально відкриють доступ у поточному режимі: Twitch — коли доступ по
// сабці, Discord — коли по Монобазі (моно-статус приходить з ролі в Discord).
const props = defineProps({
  access: { type: Object, required: true }
})

const { getProviderAuthenticationUrl } = useStrapiAuth()
const route = useRoute()

// Провайдер, з яким пішли на OAuth, треба знати на /auth/callback —
// Strapi повертає лише access_token і не каже, чий він
const startLogin = (provider) => {
  useCookie('auth_provider', { path: '/' }).value = provider
  // Повертаємось туди, звідки пішли: це і /live, і док чату в OBS
  useCookie('redirect', { path: '/' }).value = route.fullPath
  window.location.href = getProviderAuthenticationUrl(provider)
}

// Уже залогінений, але не проходить за статусом — тоді пропонуємо не
// «увійти», а «перевірити ще раз» (підписку могли щойно оформити)
const loggedInButRejected = computed(
  () => props.access.authenticated && !props.access.allowed
)
</script>

<template>
  <div class="flex flex-col items-center gap-[20px]">
    <div class="flex sm:flex-row flex-col items-center gap-[10px]">
      <button
        v-if="access.needsTwitch"
        class="flex gap-3 btn btn-neutral"
        @click="startLogin('twitch')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M11.64 5.93h1.43v4.28h-1.43m3.93-4.28H17v4.28h-1.43M7 2L3.43 5.57v12.86h4.28V22l3.58-3.57h2.85L20.57 12V2m-1.43 9.29l-2.85 2.85h-2.86l-2.5 2.5v-2.5H7.71V3.43h11.43Z"
          />
        </svg>
        <span>{{
          loggedInButRejected ? 'Перевірити Twitch' : 'Увійти через Twitch'
        }}</span>
      </button>

      <button
        v-if="access.needsMono"
        class="flex gap-3 btn btn-neutral"
        @click="startLogin('discord')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M19.27 5.33C17.94 4.71 16.5 4.26 15 4a.1.1 0 0 0-.07.03c-.18.33-.39.76-.53 1.09a16.1 16.1 0 0 0-4.8 0c-.14-.34-.35-.76-.54-1.09c-.01-.02-.04-.03-.07-.03c-1.5.26-2.93.71-4.27 1.33c-.01 0-.02.01-.03.02c-2.72 4.07-3.47 8.03-3.1 11.95c0 .02.01.04.03.05c1.8 1.32 3.53 2.12 5.24 2.65c.03.01.06 0 .07-.02c.4-.55.76-1.13 1.07-1.74c.02-.04 0-.08-.04-.09c-.57-.22-1.11-.48-1.64-.78c-.04-.02-.04-.08-.01-.11c.11-.08.22-.17.33-.25c.02-.02.05-.02.07-.01c3.44 1.57 7.15 1.57 10.55 0c.02-.01.05-.01.07.01c.11.09.22.17.33.26c.04.03.04.09-.01.11c-.52.31-1.07.56-1.64.78c-.04.01-.05.06-.04.09c.32.61.68 1.19 1.07 1.74c.03.01.06.02.09.01c1.72-.53 3.45-1.33 5.25-2.65c.02-.01.03-.03.03-.05c.44-4.53-.73-8.46-3.1-11.95c-.01-.01-.02-.02-.04-.02M8.52 14.91c-1.03 0-1.89-.95-1.89-2.12s.84-2.12 1.89-2.12c1.06 0 1.9.96 1.89 2.12c0 1.17-.84 2.12-1.89 2.12m6.97 0c-1.03 0-1.89-.95-1.89-2.12s.84-2.12 1.89-2.12c1.06 0 1.9.96 1.89 2.12c0 1.17-.83 2.12-1.89 2.12"
          />
        </svg>
        <span>{{
          loggedInButRejected ? 'Перевірити Discord' : 'Увійти через Discord'
        }}</span>
      </button>
    </div>

    <!--
      Тим, кого вже пускає, Монобазу не пропонуємо: на екрані офлайну кнопки
      лишаються тільки як спосіб перевірити статус ще раз
    -->
    <a
      v-if="access.needsMono && !access.hasMono && !access.allowed"
      href="https://base.monobank.ua/olsior#subscriptions"
      target="_blank"
      class="flex gap-3 btn btn-primary btn-sm"
    >
      <img
        class="bg-neutral rounded-full w-[22px] h-[22px]"
        src="/mono.svg"
        alt=""
      />
      <span>Оформити Монобазу</span>
    </a>
  </div>
</template>
